let codeCopy = document.querySelectorAll('.sale-coupon-btn');
let clipboard = new Clipboard(codeCopy);
clipboard.on('success', function (e) {
  let successCon = "<div class='tb-toast'>Successfully copied!</div>"
  $('body').append(successCon);
  setTimeout(function () {
    $('.tb-toast').remove();
  }, 1000)
});



$('.sale-add').click(function (e) {
  let id = $(this).data('variantid') || $(this).data('id');
  addCartFn(id)
})

var swiper = new Swiper(".serviceSwiper", {
  slidesPerView: 'auto',
  spaceBetween: 30,
  pagination: {
    el: ".swiper-pagination",
    bulletActiveClass: 'my-bullet-active',
    clickable: true,
  },
  on:{
    init: function (swiper) {
      if (!isMobile() || $(window).width() > 768) {
        this.disable();
        this.params.slidesPerView = 'auto'
      }
    },
    resize: function (swiper) {
      if (isMobile() || $(window).width() <= 768) {
        this.update();
        this.enable();
        this.params.slidesPerView = '1'
      } else {
        this.disable();
      }
    }
  }
});

